import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue-demi';
import { C2CCoupon, ShowLogoType, ShowType } from '../../types';
import { AmountBox } from '@tencent/wphk-ui';
import { OkIcon } from '@tencent/wphk-icon-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'coupon-list',
  props: {
    c2cCouponList: null
  },
  emits: ['onOpenCouponDetail'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  c2cCouponList: C2CCoupon[];
}





/** 第一个可邀请的索引 */
const firstInviteIndex = computed(() => props.c2cCouponList.findIndex(ele => !!ele.isfirstInvite));

/** 进度样式 */
const progressWidth = computed(() => {
  const len = props.c2cCouponList.length;
  let num = 0;
  if (firstInviteIndex.value < 0 || len === firstInviteIndex.value) {
    num = 100;
  } else {
    // 单个券占比
    const singlePercent = 100 / len;
    // 单个券中间占比
    const singleCenterPercent = singlePercent / 2;
    // 定位到第一个可邀请的地方
    num = singlePercent * (firstInviteIndex.value + 1) - singleCenterPercent;
  }
  return num;
});

function onOpenCouponDetail(item: C2CCoupon) {
  emits('onOpenCouponDetail', item);
}

return { __sfc: true,props, emits, firstInviteIndex, progressWidth, onOpenCouponDetail, ShowLogoType, ShowType, AmountBox, OkIcon }
}

})